import { bool, node } from "prop-types";

import styled from "styled-components";

import FnrHorizontalGap from "UI/commonContainers/FnrHorizontalGap";
import FnrVerticalGap from "UI/commonContainers/FnrVerticalGap";

import {
  accordionLabelIconWidth,
  accordionLabelInnerGap,
} from "./AccordionLabel";

/** In the Accordions label, the icon's min-width is 24px and there is a 8px gap between the icon and the title. This style aligns the title with the description */
const marginLeft = ({ $addMarginLeft }) =>
  $addMarginLeft
    ? `margin-left: ${accordionLabelIconWidth + accordionLabelInnerGap}px;`
    : "";

const SFnrHorizontalGap = styled(FnrHorizontalGap)`
  ${marginLeft}
  padding: 1px; // protect the input glow
`;

const SFnrVerticalGap = styled(FnrVerticalGap)`
  ${marginLeft}
  padding: 1px; // protect the input glow
  flex-grow: 1;
`;

const FlexSwitch = ({ horizontal, children, ...rest }) => {
  if (horizontal)
    return (
      <SFnrHorizontalGap fullWidth {...rest}>
        {children}
      </SFnrHorizontalGap>
    );
  return <SFnrVerticalGap {...rest}>{children}</SFnrVerticalGap>;
};

FlexSwitch.propTypes = { horizontal: bool, children: node };

export default FlexSwitch;
